<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>

<div [hidden]="skelition" class="row mob-m-5">
  <div class="col-md-8 col-12 p0">
    <app-no-data *ngIf="data.length <= 0 && !skelition"></app-no-data>
    <div *ngIf="data.length > 0" class="container mb-4">
      <app-table
        [unit]="tableUnit"
        [data]="data"
        (actionCall)="actionCall($event)"
      ></app-table>
    </div>
  </div>
  <div *ngIf="hasCreatePermission()" class="col-md-4 col-12 p-0">
    <div class="container mb-5">
      <h2 class="text-center color-grey">
        <i
          style="font-size: 2rem"
          class="pi pi-fw pi-plus-circle mx-2 color-grey"
        ></i
        >{{ "Add a new category" | translator }}
      </h2>
      <app-dynamic-form
        [questions]="questions"
        (sendData)="addTag($event)"
      ></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>
<!-- <hr class="hr"> -->

<!-- Confirm Modal -->
<p-confirmDialog
  [style]="{ width: '95vw', maxWidth: '800px' }"
></p-confirmDialog>

<!-- Update Data Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Header"
  [(visible)]="updateModal"
  [style]="{ width: '95vw', maxWidth: '1000px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Tag update" | translator }}</span>
  </ng-template>
  <app-dynamic-form
    *ngIf="updateModal"
    [questions]="updateQuestions"
    (sendData)="updateCategory($event)"
  ></app-dynamic-form>
</p-dialog>

<app-footer></app-footer>
